import React, { useState, useEffect } from "react";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown, DropdownItem } from "reactstrap";
import { Link } from "react-router-dom";
import AddModal from "../../../pages/pre-built/user-manage/AddModal";
import EditModal from "../../../pages/pre-built/user-manage/EditModal";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { filterRole, filterStatus } from "../../../pages/pre-built/user-manage/UserData";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  UserAvatar,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
  TooltipComponent,
  Block as BlockComp,
} from "../../../components/Component";
import { bulkActionOptions, findUpper } from "../../../utils/Utils";

const UserDataListTable = ({
  columns,
  title,
  setData,
  data,
  imageBaseURL,
  handleImageOpenPreview,
  handleToggleStatus,
  firstName,
  lastName,
}) => {
  // const [data, setData] = useState();
  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [modal, setModal] = useState({ edit: false, add: false });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({ name: "", email: "", balance: 0, phone: "", status: "Active" });
  const [editFormData, setEditFormData] = useState({ name: "", email: "", balance: 0, phone: "", status: "" });
  const [actionText, setActionText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);
  const [sort, setSortState] = useState("");
  const getFirstLastName = (item) => {
    const full = item.name || "";
    const parts = full.trim().split(" ");


    return {
      first: item.first_name || parts[0] || "",
      last: item.last_name || parts.slice(1).join(" ") || "",
    };
  };

  const stringToColor = (str) => {
    if (!str || str.trim().length === 0) {
      return "#ccc"; // fallback gray
    }

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
  };

  const sortFunc = (order, key = "name") => {
    let sortedData = [...data];

    sortedData.sort((a, b) => {
      const valA = (a[key] || "").toString().toLowerCase();
      const valB = (b[key] || "").toString().toLowerCase();

      return order === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
    });

    setData(sortedData);
  };

  const onFilterChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const onSelectChange = (e, id) => {
    const newData = data.map((item) => (item.id === id ? { ...item, checked: e.currentTarget.checked } : item));
    setData(newData);
  };

  const onActionText = (e) => {
    setActionText(e.value);
  };

  const resetForm = () => {
    setFormData({ name: "", email: "", balance: 0, phone: "", status: "Active" });
  };

  const closeModal = () => {
    setModal({ add: false, edit: false });
    resetForm();
  };

  const closeEditModal = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const onFormSubmit = (submitData) => {
    const { name, email, balance, phone, status } = submitData;
    const newId = data.length ? Math.max(...data.map((d) => Number(d.id) || 0)) + 1 : 1;
    const submittedData = {
      id: newId,
      avatarBg: "purple",
      name: name,
      first_name: name.split(" ")[0] ?? name,
      last_name: name.split(" ").slice(1).join(" ") ?? "",
      ayucash_balance: "Customer",
      email: email,
      balance: balance ?? 0,
      phone: phone ?? "",
      emailStatus: "success",
      kycStatus: "alert",
      lastLogin: "N/A",
      status: status ?? "Active",
      country: "N/A",
      image: null,
      checked: false,
      referred_by: "",
      referral_code: "",
    };
    setData([submittedData, ...data]);
    closeModal();
  };

  const onEditSubmit = (submitData) => {
    const { name, email, phone, status } = submitData;
    const newitems = data.map((item) => {
      if (item.id === editId) {
        return {
          ...item,
          name,
          first_name: name.split(" ")[0] ?? name,
          last_name: name.split(" ").slice(1).join(" ") ?? "",
          email,
          phone,
          status,
        };
      }
      return item;
    });
    setData(newitems);
    setModal({ edit: false, add: false });
  };

  const onEditClick = (id) => {
    const found = data.find((d) => d.id === id);
    if (!found) return;
    setEditFormData({
      name: found.name ?? `${found.first_name ?? ""} ${found.last_name ?? ""}`.trim(),
      email: found.email ?? "",
      balance: found.balance ?? 0,
      phone: found.phone ?? "",
      status: found.status ?? "Active",
    });
    setEditedId(id);
    setModal({ edit: true, add: false });
  };

  const suspendUser = (id) => {
    const newData = data.map((item) => (item.id === id ? { ...item, status: "Suspend" } : item));
    setData(newData);
  };

  const onActionClick = () => {
    if (actionText === "suspend") {
      const newData = data.map((item) => (item.checked ? { ...item, status: "Suspend" } : item));
      setData(newData);
    } else if (actionText === "delete") {
      const newData = data.filter((item) => !item.checked);
      setData(newData);
    }
  };

  const selectorCheck = (e) => {
    const newData = data.map((item) => ({ ...item, checked: e.currentTarget.checked }));
    setData(newData);
  };

  const toggle = () => setonSearch(!onSearch);

  const filtered = onSearchText
    ? data.filter(
        (item) =>
          (item.name || "").toString().toLowerCase().includes(onSearchText.toLowerCase()) ||
          (item.email || "").toString().toLowerCase().includes(onSearchText.toLowerCase()) ||
          (item.phone || "").toString().toLowerCase().includes(onSearchText.toLowerCase())
      )
    : data;

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [visibleColumns, setVisibleColumns] = useState({
    balance: true,
    phone: true,
    verified: true,
    status: true,
  });

  const handleColumnToggle = (columnKey) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [columnKey]: !prev[columnKey],
    }));
  };

  return (
    <React.Fragment>
      <Head title="Users"></Head>
      <Content>
        <BlockHead size="lg">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                {title}
              </BlockTitle>
              {/* <BlockDes className="text-soft">
                You have total {data.length} {title}
              </BlockDes> */}
            </BlockHeadContent>
            {/* <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <a
                        href="#export"
                        onClick={(ev) => ev.preventDefault()}
                        className="btn btn-white btn-outline-light"
                      >
                        <Icon name="download-cloud"></Icon>
                        <span>Export</span>
                      </a>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button
                        color="primary"
                        className="btn-icon"
                        //  onClick={() => setModal({ add: true, edit: false })}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent> */}
          </BlockBetween>
        </BlockHead>

        <BlockComp>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools">
                  <BlockDes className="text-soft">
                    You have total {data.length} {title}
                  </BlockDes>

                  {/* <div className="form-inline flex-nowrap gx-3">
                    <div className="form-wrap">
                      <RSelect
                        options={bulkActionOptions}
                        className="w-130px"
                        placeholder="Bulk Action"
                        onChange={(e) => onActionText(e)}
                      />
                    </div>
                    <div className="btn-wrap">
                      <span className="d-none d-md-block">
                        <Button
                          disabled={actionText !== "" ? false : true}
                          color="light"
                          outline
                          className="btn-dim"
                          onClick={() => onActionClick()}
                        >
                          Apply
                        </Button>
                      </span>
                      <span className="d-md-none">
                        <Button
                          color="light"
                          outline
                          disabled={actionText !== "" ? false : true}
                          className="btn-dim btn-icon"
                          onClick={() => onActionClick()}
                        >
                          <Icon name="arrow-right"></Icon>
                        </Button>
                      </span>
                    </div>
                  </div> */}
                </div>
                <div className="card-tools me-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    <li>
                      <div className="toggle-wrap">
                        <Button
                          className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                          onClick={() => updateTableSm(true)}
                        >
                          <Icon name="menu-right"></Icon>
                        </Button>
                        <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                          <ul className="btn-toolbar gx-1">
                            <li className="toggle-close">
                              <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                <Icon name="arrow-left"></Icon>
                              </Button>
                            </li>
                            <li>
                              {/* <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <div className="dot dot-primary"></div>
                                  <Icon name="filter-alt"></Icon>
                                </DropdownToggle>
                                <DropdownMenu
                                  end
                                  className="filter-wg dropdown-menu-xl"
                                  style={{ overflow: "visible" }}
                                >
                                  <div className="dropdown-head">
                                    <span className="sub-title dropdown-title">Filter Users</span>
                                    <div className="dropdown">
                                      <DropdownItem
                                        href="#more"
                                        onClick={(ev) => ev.preventDefault()}
                                        className="btn btn-sm btn-icon"
                                      >
                                        <Icon name="more-h"></Icon>
                                      </DropdownItem>
                                    </div>
                                  </div>
                                  <div className="dropdown-body dropdown-body-rg">
                                    <Row className="gx-6 gy-3">
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input type="checkbox" className="custom-control-input" id="hasBalance" />
                                          <label className="custom-control-label" htmlFor="hasBalance">
                                            Have Balance
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input type="checkbox" className="custom-control-input" id="hasKYC" />
                                          <label className="custom-control-label" htmlFor="hasKYC">
                                            KYC Verified
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="form-group">
                                          <label className="overline-title overline-title-alt">Role</label>
                                          <RSelect options={filterRole} placeholder="Any Role" />
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="form-group">
                                          <label className="overline-title overline-title-alt">Status</label>
                                          <RSelect options={filterStatus} placeholder="Any Status" />
                                        </div>
                                      </Col>
                                      <Col size="12">
                                        <div className="form-group">
                                          <Button color="secondary">Filter</Button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div className="dropdown-foot between">
                                    <a href="#reset" onClick={(ev) => ev.preventDefault()} className="clickable">
                                      Reset Filter
                                    </a>
                                    <a href="#save" onClick={(ev) => ev.preventDefault()}>
                                      Save Filter
                                    </a>
                                  </div>
                                </DropdownMenu>
                              </UncontrolledDropdown> */}
                            </li>
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <Icon name="setting"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end className="dropdown-menu-xs">
                                  <ul className="link-check">
                                    <li>
                                      <span>Show</span>
                                    </li>
                                     
                                    <li className={itemPerPage === 25 ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(25);
                                        }}
                                      >
                                        25
                                      </DropdownItem>
                                    </li>
                                    <li className={itemPerPage === 50 ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(50);
                                        }}
                                      >
                                        50
                                      </DropdownItem>
                                    </li>
                                    <li className={itemPerPage === 100 ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(100);
                                        }}
                                      >
                                        100
                                      </DropdownItem>
                                    </li>
                                     <li className={itemPerPage === 250 ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(250);
                                        }}
                                      >
                                        250
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                  <ul className="link-check">
                                    <li>
                                      <span>Order</span>
                                    </li>
                                    <li className={sort === "dsc" ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSortState("dsc");
                                          sortFunc("desc", "email");
                                        }}
                                      >
                                        DESC
                                      </DropdownItem>
                                    </li>
                                    <li className={sort === "asc" ? "active" : ""}>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSortState("asc");

                                          sortFunc("asc", "email");
                                        }}
                                      >
                                        ASC
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody compact>
              <DataTableHead>
                <DataTableRow className="nk-tb-col-check">
                  {/* <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={(e) => selectorCheck(e)}
                      id="uid"  
                    />
                    <label className="custom-control-label" htmlFor="uid"></label>
                  </div> */}
                </DataTableRow>

                {columns.map((col) => (
                  <DataTableRow key={col.key} size={col.size || ""}>
                    <span className="sub-text fw-bold">{col.label}</span>
                  </DataTableRow>
                ))}
                <DataTableRow className="text-center">
                  <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                    Status
                  </span>
                </DataTableRow>

                <DataTableRow className="nk-tb-col-tools text-end">
                  {/* <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-xs btn-outline-light btn-icon dropdown-toggle">
                      <Icon name="plus" />
                    </DropdownToggle>

                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-tidy sm no-bdr">
                        <li>
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="bl"
                              checked={visibleColumns.balance}
                              onChange={() => handleColumnToggle("balance")}
                            />
                            <label className="custom-control-label" htmlFor="bl">
                              Balance
                            </label>
                          </div>
                        </li>

                        <li>
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="ph"
                              checked={visibleColumns.phone}
                              onChange={() => handleColumnToggle("phone")}
                            />
                            <label className="custom-control-label" htmlFor="ph">
                              Phone
                            </label>
                          </div>
                        </li>

                        <li>
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="vri"
                              checked={visibleColumns.verified}
                              onChange={() => handleColumnToggle("verified")}
                            />
                            <label className="custom-control-label" htmlFor="vri">
                              Verified
                            </label>
                          </div>
                        </li>

                        <li>
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="st"
                              checked={visibleColumns.status}
                              onChange={() => handleColumnToggle("status")}
                            />
                            <label className="custom-control-label" htmlFor="st">
                              Status
                            </label>
                          </div>
                        </li>
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown> */}
                  {/* <div className="fw-bold">Action</div> */}
                </DataTableRow>
              </DataTableHead>

              {currentItems.length > 0
                ? currentItems.map((item) => (
                    <DataTableItem key={item.id}>
                      <DataTableRow className="nk-tb-col-check">
                        {/* <div className="custom-control custom-control-sm custom-checkbox notext">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            checked={!!item.checked}
                            id={item.id + "uid1"}
                            onChange={(e) => onSelectChange(e, item.id)}
                          />
                          <label className="custom-control-label" htmlFor={item.id + "uid1"}></label>
                        </div> */}
                      </DataTableRow>

                      {columns.map((col) => (
                        <DataTableRow key={col.key} size={col.size || ""}>
                          {col.type === "image" ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {item[col.key] ? (
                                <img
                                  onClick={() =>
                                    handleImageOpenPreview(
                                      item[col.key]?.includes("https")
                                        ? item[col.key]
                                        : `${imageBaseURL}${item[col.key]}`
                                    )
                                  }
                                  src={
                                    item[col.key]?.includes("https") ? item[col.key] : `${imageBaseURL}${item[col.key]}`
                                  }
                                  alt={item.first_name + " " + item.last_name}
                                  style={{
                                    width: 35,
                                    height: 35,
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: 35,
                                    height: 35,
                                    borderRadius: "50%",
                                    backgroundColor: stringToColor(
                                      `${getFirstLastName(item).first}${getFirstLastName(item).last}`
                                    ),
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    textTransform: "uppercase",
                                    fontSize: 13,
                                  }}
                                >
                                  {`${getFirstLastName(item).first?.[0] || ""}${
                                    getFirstLastName(item).last?.[0] || ""
                                  }`}
                                </div>
                              )}

                              <span className="text-dark fw-bold">
                                {`${getFirstLastName(item).first} ${getFirstLastName(item).last}`}
                              </span>
                            </div>
                          ) : col.key === "status" ? (
                            <span
                              className={`tb-status text-${
                                item.status === "Active" ? "success" : item.status === "Pending" ? "warning" : "danger"
                              }`}
                            >
                              {item.status}
                            </span>
                          ) : (
                            <span>{item[col.key] || "-"}</span>
                          )}
                        </DataTableRow>
                      ))}

                      <DataTableRow className="text-center">
                        {" "}
                        <span
                          onClick={() => handleToggleStatus(item)}
                          className={`fw-700 ${item.status ? "text-success" : "text-danger"}`}
                          style={{ cursor: "pointer", textTransform: "capitalize" }}
                        >
                          {item.status ? "Active" : "InActive"}
                        </span>
                      </DataTableRow>

                      <DataTableRow className="nk-tb-col-tools">
                        {/* <ul className="nk-tb-actions gx-1">
                          <li
                            className="nk-tb-action-hidden"
                            // onClick={() => onEditClick(item.id)}
                          >
                            <TooltipComponent
                              tag="a"
                              containerClassName="btn btn-trigger btn-icon"
                              id={"edit" + item.id}
                              icon="edit-alt-fill"
                              direction="top"
                              text="Edit"
                            />
                          </li>
                          {item.status !== "Suspend" && (
                            <li className="nk-tb-action-hidden" onClick={() => suspendUser(item.id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"suspend" + item.id}
                                icon="user-cross-fill"
                                direction="top"
                                text="Suspend"
                              />
                            </li>
                          )}
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  <li
                                  // onClick={() => onEditClick(item.id)}
                                  >
                                    <DropdownItem tag="a" href="#edit" onClick={(ev) => ev.preventDefault()}>
                                      <Icon name="edit" />
                                      <span>Edit</span>
                                    </DropdownItem>
                                  </li>
                                  <li>
                                    <DropdownItem tag="a" href="#view" onClick={(ev) => ev.preventDefault()}>
                                      <Icon name="eye" />
                                      <span>View</span>
                                    </DropdownItem>
                                  </li>
                                  {item.status !== "Suspend" && (
                                    <>
                                      <li className="divider"></li>
                                      <li onClick={() => suspendUser(item.id)}>
                                        <DropdownItem tag="a" href="#suspend" onClick={(ev) => ev.preventDefault()}>
                                          <Icon name="na" />
                                          <span>Suspend User</span>
                                        </DropdownItem>
                                      </li>
                                    </>
                                  )}
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul> */}
                      </DataTableRow>
                    </DataTableItem>
                  ))
                : null}
            </DataTableBody>

            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={filtered.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </BlockComp>

        <AddModal
          modal={modal.add}
          formData={formData}
          setFormData={setFormData}
          closeModal={closeModal}
          onSubmit={onFormSubmit}
          filterStatus={filterStatus}
        />
        <EditModal
          modal={modal.edit}
          formData={editFormData}
          setFormData={setEditFormData}
          closeModal={closeEditModal}
          onSubmit={onEditSubmit}
          filterStatus={filterStatus}
        />
      </Content>
    </React.Fragment>
  );
};

export default UserDataListTable;
